var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "aside" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _c("div", { staticClass: "doc-nav-title" }, [_vm._v("开发指南")]),
            _vm._v(" "),
            _vm._l(_vm.asideTitleArr, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "doc-nav-item",
                  on: {
                    click: function($event) {
                      _vm.goRouter(item.path)
                    }
                  }
                },
                [_vm._v(_vm._s(item.name))]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "comp" },
          [
            _c("div", { staticClass: "doc-comp-title" }, [_vm._v("组件")]),
            _vm._v(" "),
            _vm._l(_vm.asideContentArr, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "doc-comp" },
                [
                  _c("div", { staticClass: "doc-comp-banner" }, [
                    _vm._v(_vm._s(item.name))
                  ]),
                  _vm._v(" "),
                  _vm._l(item.Arr, function(it, ind) {
                    return _c(
                      "div",
                      {
                        key: ind,
                        staticClass: "doc-comp-item",
                        on: {
                          click: function($event) {
                            _vm.goRouter(it.path)
                          }
                        }
                      },
                      [_vm._v(_vm._s(it.name))]
                    )
                  })
                ],
                2
              )
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [_c("router-view", { staticClass: "markdown" })],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "header-title" }, [_vm._v("Mi-Vant")]),
      _vm._v(" "),
      _c("div", { staticClass: "header-git" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/preview/App.vue?vue&type=template&id=dad52a1e&
// module id = null
// module chunks = 